export default function Reviews() {
  return <h1>Reviews</h1>;
}
